webpackJsonp([70144966829960],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(149);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebookOfficial = function FaFacebookOfficial(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.4 2.9q0.8 0 1.3 0.5t0.6 1.4v30.4q0 0.8-0.6 1.4t-1.3 0.5h-8.7v-13.2h4.4l0.7-5.2h-5.1v-3.3q0-1.3 0.5-1.9t2-0.6l2.7 0v-4.7q-1.4-0.2-3.9-0.2-3.1 0-4.9 1.8t-1.8 5.1v3.8h-4.5v5.2h4.5v13.2h-16.4q-0.8 0-1.3-0.5t-0.6-1.4v-30.4q0-0.8 0.6-1.4t1.3-0.5h30.5z' })
	        )
	    );
	};
	
	exports.default = FaFacebookOfficial;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CareersModule = __webpack_require__(204);
	
	var _CareersModule2 = _interopRequireDefault(_CareersModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Careers = function Careers(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _CareersModule2.default.careers },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Careers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There are currently no openings, but resumes may be submitted to ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:inquiries@dom-sys.com' },
	        'inquiries@dom-sys.com'
	      )
	    )
	  );
	};
	
	exports.default = Careers;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"careers":"src-components-Careers----Careers-module---careers---271R8"};

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(105);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _InputButtonModule = __webpack_require__(206);
	
	var _InputButtonModule2 = _interopRequireDefault(_InputButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_InputButtonModule2.default);
	
	var InputButton = function InputButton(props) {
	  var className = cx({
	    btn: true,
	    orange: props.orange,
	    large: props.large
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _InputButtonModule2.default.button },
	    _react2.default.createElement(
	      'button',
	      { className: className },
	      props.title
	    )
	  );
	};
	
	exports.default = InputButton;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dark":"#00171F","blue":"#00A8E8","white":"#FFFFFF","green":"#99C24D","btn":"src-components-InputButton----InputButton-module---btn---38B_r","orange":"src-components-InputButton----InputButton-module---orange---1tX-g src-components-InputButton----InputButton-module---btn---38B_r","normal":"src-components-InputButton----InputButton-module---normal---3TkdC src-components-InputButton----InputButton-module---btn---38B_r","large":"src-components-InputButton----InputButton-module---large---3ji-u src-components-InputButton----InputButton-module---btn---38B_r"};

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"white":"#FFFFFF","bp":"(min-width: 700px)","outer":"src-pages----ContactPage-module---outer---NF2qv","hidden":"src-pages----ContactPage-module---hidden---3Vmi5","overlay":"src-pages----ContactPage-module---overlay---3cyyW","wrapper":"src-pages----ContactPage-module---wrapper---VCOsN","formColumn":"src-pages----ContactPage-module---formColumn---3omaQ","infoColumn":"src-pages----ContactPage-module---infoColumn---x9M-9","socialIcon":"src-pages----ContactPage-module---socialIcon---2dbh5"};

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageWrapper = __webpack_require__(56);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _TextContainer = __webpack_require__(104);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _InputButton = __webpack_require__(155);
	
	var _InputButton2 = _interopRequireDefault(_InputButton);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _facebookOfficial = __webpack_require__(797);
	
	var _facebookOfficial2 = _interopRequireDefault(_facebookOfficial);
	
	var _Careers = __webpack_require__(153);
	
	var _Careers2 = _interopRequireDefault(_Careers);
	
	var _ContactPageModule = __webpack_require__(636);
	
	var _ContactPageModule2 = _interopRequireDefault(_ContactPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      contact_type: 'sales'
	    }, _this.handleChange = function (e) {
	      var _this$setState;
	
	      var target = e.target;
	      var value = target.value;
	      var name = target.name;
	
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactPage.prototype.render = function render() {
	    function RenderForm(props) {
	      var contact_type = props.contact_type;
	      if (props.contact_type == 'sales') {
	        return _react2.default.createElement(
	          'form',
	          { name: 'contact_sales', method: 'POST', 'data-netlify': 'true' },
	          _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact_sales' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name_sales' },
	              'Name:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'name_sales', name: 'name' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email_sales' },
	              'Email:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'email_sales', name: 'email' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'phone_sales' },
	              'Phone:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'phone_sales', name: 'phone' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message_sales' },
	              'Message:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('textarea', { id: 'message_sales', name: 'message' })
	          ),
	          _react2.default.createElement(_InputButton2.default, { title: 'Submit' })
	        );
	      }
	      if (props.contact_type == 'technical') {
	        return _react2.default.createElement(
	          'form',
	          { name: 'contact_technical', method: 'POST', 'data-netlify': 'true' },
	          _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact_technical' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name_tech' },
	              'Name:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'name_tech', name: 'name' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email_tech' },
	              'Email:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'email_tech', name: 'email' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'phone_tech' },
	              'Phone:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('input', { type: 'text', id: 'phone_tech', name: 'phone' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message_tech' },
	              'Message:'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('textarea', { id: 'message_tech', name: 'message' })
	          ),
	          _react2.default.createElement(_InputButton2.default, { title: 'Submit' })
	        );
	      }
	      if (props.contact_type == '') {
	        return _react2.default.createElement('div', null);
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _ContactPageModule2.default.outer },
	      _react2.default.createElement('div', { className: _ContactPageModule2.default.overlay }),
	      _react2.default.createElement(
	        _PageWrapper2.default,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Contact - Dominion Systems, LLC', meta: [] }),
	        _react2.default.createElement(
	          _Inner2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _ContactPageModule2.default.wrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _ContactPageModule2.default.formColumn },
	              _react2.default.createElement(
	                _TextContainer2.default,
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Contact Dominion Systems'
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement('input', {
	                  type: 'radio',
	                  name: 'contact_type',
	                  id: 'sales',
	                  value: 'sales',
	                  onChange: this.handleChange,
	                  checked: this.state.contact_type === 'sales'
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'sales' },
	                  'Sales'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('input', {
	                  type: 'radio',
	                  name: 'contact_type',
	                  id: 'technical',
	                  value: 'technical',
	                  onChange: this.handleChange,
	                  checked: this.state.contact_type === 'technical'
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'technical' },
	                  'Technical'
	                ),
	                _react2.default.createElement(RenderForm, { contact_type: this.state.contact_type })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ContactPageModule2.default.infoColumn },
	              _react2.default.createElement(
	                _TextContainer2.default,
	                null,
	                _react2.default.createElement(_Careers2.default, null),
	                _react2.default.createElement('div', {
	                  dangerouslySetInnerHTML: {
	                    __html: this.props.data.contact.edges[0].node.childMarkdownRemark.html
	                  }
	                }),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Connect'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: _ContactPageModule2.default.socialIcon,
	                      href: this.props.data.contact.edges[0].node.childMarkdownRemark.frontmatter.facebook_url
	                    },
	                    _react2.default.createElement(_facebookOfficial2.default, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-ab0c435b8a7a0b7764e2.js